import { format } from 'date-fns'

// Note: Format is -> 2026-01-31 (ISO date, used for API query params)
export const formatDateIso = (date: Date | number | string): string => {
  return format(date, 'yyyy-MM-dd')
}
